import {ModalProps} from "react-bootstrap/Modal";
import {Button, Form, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {actions, ICreateRename} from "../../store/sliceModal";
import {fetchCreateFolder, fetchRenameFile} from "../../fetch/FileRequest";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";

const ModalCreateRename:FC<ModalProps & ICreateRename>= (props) => {
    const {id, title, file, isRename, onHide} = props
    const dispatch = useDispatch<AppDispatch>();
    const [nameState, setNameState] = useState('')
    useEffect(() => {
        if (isRename) {
            setNameState(file?.name!)
        } else {
            setNameState('')
        }
    },[file?.name])


    const click = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        if (props.isRename) {
            fetchRenameFile(file?.id!, nameState, file?.folder!)
        } else {
            fetchCreateFolder(id, nameState);
        }
        setNameState('')
        if (onHide) {
            onHide()
        }
    },[nameState])


    return (
        <Modal
            {...props}
            size={"sm"}
        //    centered
        >
            <Modal.Header closeButton>
                {title}
            </Modal.Header>
            <Modal.Body>

                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <Form.Control
                    required
                    type="text"
                    placeholder="Имя"
                    value={nameState}
                    style={{marginBottom:" 10px"}}
                    onChange={(event) => setNameState(event.target.value)}
                />
                <Button style={{width: "100px"}} variant={"outline-primary"} onClick={click}>ОК</Button>
            </div>
            </Modal.Body>
        </Modal>
    );
}

export default memo(ModalCreateRename)
